import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CancelIcon from '@mui/icons-material/Cancel';

export default function NotiAlert({
  open,
  title,
  value,
  onButtonClick,
  errorValue,
  selectedOption,
}) {
  return (
    <div>
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth
        maxWidth="xs"
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '15px',
          },
        }}
      >
        <DialogActions sx={{ backgroundColor: '#D9D9D9' }}>
          <IconButton aria-label="close" onClick={onButtonClick}>
            <CancelOutlinedIcon />
          </IconButton>
        </DialogActions>

        <DialogContent dividers>
          <div className="flex  justify-center">
            {value === 'error' ? (
              <ErrorIcon sx={{ fontSize: '70px', color: 'primary.light' }} />
            ) : value === 'cancel' ? (
              <CancelIcon sx={{ fontSize: '70px', color: 'red' }} />
            ) : (
              <CheckCircleIcon
                sx={{ fontSize: '70px', color: 'primary.light' }}
              />
            )}
          </div>
          <div className=" justify-center  mt-2 mb-8">
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                color: value === 'cancel' ? 'red' : 'primary.light',
              }}
            >
              <div className="flex justify-center text-center">{title}</div>
            </Typography>
            <Typography
              variant="h7"
              gutterBottom
              sx={{
                color: 'red ',
              }}
            >
              <div className="flex justify-center text-center">
                {errorValue ? errorValue : ''}
              </div>
            </Typography>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
